import i18n from 'i18next';
import type { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import accountsTranslations from '../locales/en/accounts.json';
import analyticsTranslations from '../locales/en/analytics.json';
import appTranslations from '../locales/en/app.json';
import authTranslations from '../locales/en/auth.json';
import commonTranslations from '../locales/en/common.json';
import dashboardTranslations from '../locales/en/dashboard.json';
import emptyDashboardTranslations from '../locales/en/emptyDashboard.json';
import errorsTranslations from '../locales/en/errors.json';
import exportTranslations from '../locales/en/export.json';
import goalCreationPromptTranslations from '../locales/en/goalCreationPrompt.json';
import goalsTranslations from '../locales/en/goals.json';
import loadingTranslations from '../locales/en/loading.json';
import navigationTranslations from '../locales/en/navigation.json';
import onboardingTranslations from '../locales/en/onboarding.json';
import performanceTranslations from '../locales/en/performance.json';
import portfolioTranslations from '../locales/en/portfolio.json';
import profileTranslations from '../locales/en/profile.json';
import settingsTranslations from '../locales/en/settings.json';
import validationTranslations from '../locales/en/validation.json';
import websiteTranslations from '../locales/en/website.json';

// Aggregate all translations with proper namespacing
const enTranslations = {
  accounts: accountsTranslations,
  analytics: analyticsTranslations,
  app: appTranslations,
  auth: authTranslations,
  common: commonTranslations,
  dashboard: dashboardTranslations,
  emptyDashboard: emptyDashboardTranslations,
  errors: errorsTranslations,
  export: exportTranslations,
  goalCreationPrompt: goalCreationPromptTranslations,
  goals: goalsTranslations,
  loading: loadingTranslations,
  navigation: navigationTranslations,
  onboarding: onboardingTranslations,
  performance: performanceTranslations,
  portfolio: portfolioTranslations,
  profile: profileTranslations,
  settings: settingsTranslations,
  validation: validationTranslations,
  website: websiteTranslations,
};

// the translations
const resources = {
  en: {
    translation: enTranslations,
  },
};

export const initI18n = (options: Partial<InitOptions> = {}) => {
  const config = {
    resources,

    lng: 'en', // Force English language

    // Language to use if translations in user language are not available
    fallbackLng: 'en',

    // Default namespace
    defaultNS: 'translation',
    ns: ['translation'],

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Detection options (can be overridden)
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      ...options.detection,
    },

    // Backend options (can be overridden)
    // backend: {
    //   loadPath: '/locales/{{lng}}/{{ns}}.json',
    //   ...options.backend,
    // },

    // Disable plural resolver for React Native compatibility
    compatibilityJSON: 'v3' as const,

    ...options,
  };

  i18n.use(initReactI18next).init(config);

  return i18n;
};
export { i18n };
